import { isFulfilled, isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { AnyAsyncThunk, FulfilledActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { trySendFullfilledMessage, trySendRejectedMessage } from '@vxui/common';

const isMutation = (action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>): boolean =>
  action?.meta?.arg?.type === 'mutation';

export const toastMiddleware: Middleware = () => next => action => {
  if (isRejectedWithValue(action)) {
    trySendRejectedMessage('calculator.toast.api.rejected', action.meta.arg.endpointName, action.payload?.data) ||
      trySendRejectedMessage('toast.api.rejected', action.meta.arg.endpointName, action.payload?.data);
  } else if (isFulfilled(action) && isMutation(action)) {
    trySendFullfilledMessage('calculator.toast.api.fulfilled', action.meta.arg.endpointName) ||
      trySendFullfilledMessage('toast.api.fulfilled', action.meta.arg.endpointName);
  }

  return next(action);
};
